<template>
  <div id="app">
    <div>
      <div class="top-bar">
        <div class="right" v-if="username">
          <span @click="logout">欢迎：{{ username }}</span>
        </div>
      </div>
      <router-view v-if="pageName == 'login'" />
      <el-row v-else>
        <userInfo></userInfo>

        <el-col :span="4">
          <el-menu :default-active="pagePath" class="el-menu-vertical-demo">
            <el-submenu index="purview">
              <template slot="title">
                <span>权限管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/sysuser" @click="$router.push('/sysuser')" v-if="menuList.includes('系统用户')">系统用户
                </el-menu-item>
                <el-menu-item index="/role" @click="$router.push('/role')" v-if="menuList.includes('角色管理')">角色管理
                </el-menu-item>
                <el-menu-item index="/per" @click="$router.push('/per')" v-if="menuList.includes('权限管理')">权限管理
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="user">
              <template slot="title">
                <span>用户管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/user" @click="$router.push('/user')" v-if="menuList.includes('用户管理')">
                  <span slot="title">用户管理</span>
                </el-menu-item>
                <el-menu-item index="/talentpool" @click="$router.push('/talentpool')" v-if="menuList.includes('用户管理')">
                  <span slot="title">人才库</span>
                </el-menu-item>
                <el-menu-item index="/usercheck" @click="$router.push('/usercheck')" v-if="menuList.includes('入驻管理')">
                  <span slot="title">入驻管理</span>
                </el-menu-item>
                <el-menu-item index="/resumeList" @click="$router.push('/resumeList')" v-if="menuList.includes('简历管理')">
                  <span slot="title">简历管理</span>
                </el-menu-item>
                <el-menu-item index="/userlevel" @click="$router.push('/userlevel')" v-if="menuList.includes('评级管理')">
                  <span slot="title">评级管理</span>
                </el-menu-item>
                <el-menu-item index="/clients" @click="$router.push('/clients')" v-if="menuList.includes('客户管理')">
                  <span slot="title">客户管理</span>
                </el-menu-item>
                <el-menu-item index="/invites" @click="$router.push('/invites')" v-if="menuList.includes('邀请用户管理')">
                  <span slot="title">邀请用户管理</span>
                </el-menu-item>
                <el-menu-item index="/follows" @click="$router.push('/follows')" v-if="menuList.includes('跟进记录管理')">
                  <span slot="title">跟进记录管理</span>
                </el-menu-item>
                <el-menu-item index="/sessions" @click="$router.push('/sessions')" v-if="menuList.includes('沟通记录管理')">
                  <span slot="title">沟通记录</span>
                </el-menu-item>
                <el-menu-item index="/bans" @click="$router.push('/bans')" v-if="menuList.includes('封号管理')">
                  <span slot="title">封号管理</span>
                </el-menu-item>
                <el-menu-item index="/ents" @click="$router.push('/ents')" v-if="menuList.includes('企业管理')">
                  <span slot="title">企业管理</span>
                </el-menu-item>
                <el-menu-item index="/violations" @click="$router.push('/violations')" v-if="menuList.includes('违规人才管理')">
                  <span slot="title">违规人才管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="activity">
              <template slot="title">
                <span>广告系统</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/activities" @click="$router.push('/activities')" v-if="menuList.includes('首页活动管理')">
                  <span slot="title">首页活动管理</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/talentActivity" @click="$router.push('/talentActivity')" v-if="menuList.includes('首页活动管理')">
                  <span slot="title">广告管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="bean">
              <template slot="title">
                <span>云豆管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/bean" @click="$router.push('/bean')" v-if="menuList.includes('云豆明细')">
                  <span slot="title">云豆明细</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/bean/beanConfig" @click="$router.push('/bean/beanConfig')">
                  <span slot="title">云豆配置</span>
                </el-menu-item>
              </el-menu-item-group>
              <el-menu-item-group>
                <el-menu-item index="/bean/orders" @click="$router.push('/bean/orders')"
                  v-if="menuList.includes('云豆订单管理')">
                  <span slot="title">云豆订单管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="service">
              <template slot="title">
                <span>服务管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/service-check" @click="$router.push('/service-check')"
                  v-if="menuList.includes('技能审核')">
                  <span slot="title">服务审核</span>
                </el-menu-item>
                <el-menu-item index="/services" @click="$router.push('/services')" v-if="menuList.includes('技能管理')">
                  <span slot="title">服务管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="job">
              <template slot="title">
                <span>职位管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/jobs" @click="$router.push('/jobs')" v-if="menuList.includes('需求订单')">
                  <span slot="title">职位管理</span>
                </el-menu-item>
                <el-menu-item index="/standardJob" @click="$router.push('/standardJob')" v-if="menuList.includes('需求订单')">
                  <span slot="title">标准岗位管理</span>
                </el-menu-item>
                <el-menu-item index="/quotes" @click="$router.push('/quotes')" v-if="menuList.includes('需求订单')">
                  <span slot="title">报价管理</span>
                </el-menu-item>
                <el-menu-item index="/matchs" @click="$router.push('/matchs')" v-if="menuList.includes('匹配管理')">
                  <span slot="title">匹配管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="order">
              <template slot="title">
                <span>订单管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/orders" @click="$router.push('/orders')" v-if="menuList.includes('需求订单')">
                  <span slot="title">订单管理</span>
                </el-menu-item>
                <el-menu-item index="/appeals" @click="$router.push('/appeals')" v-if="menuList.includes('申诉管理')">
                  <span slot="title">申诉管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="taskManage">
              <template slot="title">
                <span>任务管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/taskManage" @click="$router.push('/taskManage/index')">
                  <span slot="title">任务管理</span>
                </el-menu-item>
                <el-menu-item index="/taskOrder" @click="$router.push('/taskManage/taskOrder')">
                  <span slot="title">任务订单管理</span>
                </el-menu-item>
                <el-menu-item index="/taskAppeals" @click="$router.push('/taskManage/taskAppeals')">
                  <span slot="title">任务申诉管理</span>
                </el-menu-item>
                <el-menu-item index="/taskFinal" @click="$router.push('/taskManage/taskFinal')">
                  <span slot="title">任务结算单管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <el-submenu index="prop">
              <template slot="title">
                <span>道具管理</span>
              </template>
              <el-menu-item-group>
                <el-submenu index="prop-1">
                  <template slot="title">甲方道具</template>
                  <el-menu-item index="/prop/partyA/odrer" @click="$router.push('/prop/partyA/odrer')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具订单</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyA/daily" @click="$router.push('/prop/partyA/daily')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">天天畅聊</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyA/propConfig" @click="$router.push('/prop/partyA/propConfig')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具包配置</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyA/activityConfig" @click="$router.push('/prop/partyA/activityConfig')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具包活动配置</span>
                  </el-menu-item>
                </el-submenu>
                <el-submenu index="prop-2">
                  <template slot="title">乙方道具</template>
                  <el-menu-item index="/prop/partyB/odrer" @click="$router.push('/prop/partyB/odrer')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具订单</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyB/daily" @click="$router.push('/prop/partyB/daily')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">每天投一投</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyB/propConfig" @click="$router.push('/prop/partyB/propConfig')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具包配置</span>
                  </el-menu-item>
                  <el-menu-item index="/prop/partyB/activityConfig" @click="$router.push('/prop/partyB/activityConfig')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">道具包活动配置</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item index="/prop/refund" @click="$router.push('/prop/refund')"
                  v-if="menuList.includes('提现管理')">
                  <span slot="title">道具退款</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>


            <el-submenu index="finance">
              <template slot="title">
                <span>财务管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/pay" @click="$router.push('/pay')" v-if="menuList.includes('充值管理')">
                  <span slot="title">充值管理</span>
                </el-menu-item>
                <el-submenu index="6-2">
                  <template slot="title">提现管理</template>
                  <el-menu-item index="/withdrawal/1" @click="$router.push('/withdrawal/1')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">甲方提现</span>
                  </el-menu-item>
                  <el-menu-item index="/withdrawal/2" @click="$router.push('/withdrawal/2')"
                    v-if="menuList.includes('提现管理')">
                    <span slot="title">乙方提现</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item index="/prepay" @click="$router.push('/prepay')" v-if="menuList.includes('预付款审批')">
                  <span slot="title">预付款审批</span>
                </el-menu-item>
                <el-menu-item index="/settlement" @click="$router.push('/settlement')" v-if="menuList.includes('结算管理')">
                  <span slot="title">结算管理</span>
                </el-menu-item>
                <el-menu-item index="/invoices" @click="$router.push('/invoices')" v-if="menuList.includes('发票管理')">
                  <span slot="title">发票管理</span>
                </el-menu-item>
                <el-menu-item index="/accounts" @click="$router.push('/accounts')" v-if="menuList.includes('账户管理')">
                  <span slot="title">账户管理</span>
                </el-menu-item>
                <el-menu-item index="/coupon/activities" @click="$router.push('/coupon/activities')"
                  v-if="menuList.includes('优惠券管理')">
                  <span slot="title">优惠券管理</span>
                </el-menu-item>
                <el-menu-item index="/coupon/packageList" @click="$router.push('/coupon/packageList')">
                  <span slot="title">优惠券套票管理</span>
                </el-menu-item>
                <el-menu-item index="/coupon/coupons" @click="$router.push('/coupons')">
                  <span slot="title">优惠券使用明细</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="category">
              <template slot="title">
                <span>类目管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/cates" @click="$router.push('/cates')" v-if="menuList.includes('工作类别管理')">
                  <span slot="title">工作类别管理</span>
                </el-menu-item>
                <el-menu-item index="/skills" @click="$router.push('/skills')" v-if="menuList.includes('专业技能管理')">
                  <span slot="title">专业技能管理</span>
                </el-menu-item>
                <el-menu-item index="/cate/hots" @click="$router.push('/cate/hots')" v-if="menuList.includes('热门类目管理')">
                  <span slot="title">热门类目管理</span>
                </el-menu-item>
                <el-menu-item index="/solutions" @click="$router.push('/solutions')" v-if="menuList.includes('解决方案管理')">
                  <span slot="title">解决方案管理</span>
                </el-menu-item>
                <el-menu-item index="/search" @click="$router.push('/search')" v-if="menuList.includes('热门搜索词管理')">
                  <span slot="title">热门搜索词管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="imCallMange">
              <template slot="title">
                <span>IM-通话管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/imCallMange" @click="$router.push('/imCallMange/index')">
                  <span slot="title">通话记录管理</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="system">
              <template slot="title">
                <span>系统设置</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="/feedbacks" @click="$router.push('/feedbacks')" v-if="menuList.includes('反馈管理')">
                  <span slot="title">反馈管理</span>
                </el-menu-item>
                <el-menu-item index="/payway" @click="$router.push('/payway')" v-if="false">
                  <span slot="title">支付通道</span>
                </el-menu-item>
                <el-menu-item index="/log" @click="$router.push('/log')" v-if="menuList.includes('系统日志')">
                  <span slot="title">系统日志</span>
                </el-menu-item>
                <el-menu-item index="/reportlog" @click="$router.push('/reportlog')" v-if="menuList.includes('举报日志')">
                  <span slot="title">举报日志</span>
                </el-menu-item>
                <el-menu-item index="/match/tool" @click="$router.push('/match/tool')" v-if="menuList.includes('匹配测试工具')">
                  <span slot="title">匹配测试工具</span>
                </el-menu-item>
                <el-menu-item index="/match/config" @click="$router.push('/match/config')"
                  v-if="menuList.includes('匹配场景管理')">
                  <span slot="title">匹配场景管理</span>
                </el-menu-item>
                <el-menu-item index="/wx/push" @click="$router.push('/wx/push')" v-if="menuList.includes('微信推送')">
                  <span slot="title">微信推送</span>
                </el-menu-item>
                <el-menu-item index="/config" @click="$router.push('/config')" v-if="menuList.includes('全局配置')">
                  <span slot="title">全局配置</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </el-col>
        <el-col :span="20">
          <div class="content">
            <router-view @updateMenu="updateMenu" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import userInfo from "./components/common/userInfo";
import api from "./views/api";
let { menu } = api;

export default {
  name: "App",
  data() {
    return {
      menuList: [],
    };
  },
  components: {
    userInfo,
  },
  computed: {
    pageName() {
      return this.$route.name;
    },
    pagePath() {
      return this.$route.path;
    },
    username() {
      return localStorage.getItem("username");
    },
  },
  methods: {
    logout() {
      localStorage.removeItem("username");
      localStorage.removeItem("neworkadmintoken");
      localStorage.removeItem("menuList");
      location.href = "/login";
    },
    fetch() {
      menu();
    },
    updateMenu() {
      this.menuList = JSON.parse(localStorage.getItem("menuList")) || [];
    },
  },
  created() {
    this.menuList = JSON.parse(localStorage.getItem("menuList")) || [];
  },
  mounted() {
    if (this.username) {
      this.fetch();
    }
  },
  watch: {
    $route() {
      this.fetch();
    },
  },
};
</script>
<style>
body,
html {
  width: 100%;
  height: 100%;
}

div {
  margin: 0;
  padding: 0;
}

#app {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  min-width: 1000px;
}

.top-bar {
  background: #1ab394;
  text-align: center;
  color: #ffffff;
  font-size: 30px;
  text-shadow: 10px 10px 4px 4px rgba(0, 0, 0, 0.8);
  position: relative;
  height: 50px;
}

.el-submenu .el-menu-item {
  min-width: inherit;
}

.right {
  position: absolute;
  right: 20px;
  top: 0;
  bottom: 0;
  font-size: 14px;
}

.logout {
  color: #ffffff;
  font-size: 25px;
  display: inline-block;
  margin-left: 5px;
  text-decoration: none;
}

.avatar {}

.left {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  font-size: 14px;
}

.left a {
  display: block;
  height: 50px;
}

.left span {
  display: block;
  line-height: 50px;
  height: 50px;
  text-align: left;
}

.right span {
  display: block;
  line-height: 50px;
  height: 50px;
  text-align: left;
}

.content {
  /* padding: 20px; */
  padding: 10px 20px 10px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.tcenter {
  text-align: center;
}

.cl:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.cl {
  *zoom: 1;
}

.el-pagination {
  text-align: right;
}

.code {
  padding: 10px;
  background: #eee;
  word-break: break-all;
}

#app .el-radio+.el-radio {
  margin-left: 0;
}

#app .el-radio {
  margin-right: 30px;
  margin: 5px 30px 5px 0;
}

.el-table {
  width: 99% !important;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

.el-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  border: dashed 1px #dcdfe6;
  text-align: center;
}

.el-upload .avatar-uploader-icon {
  font-size: 30px;
}

.el-upload .el-input {
  display: none;
}

.el-upload img {
  max-width: 100%;
  max-height: 100%;
}

.w640 {
  width: 640px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue